import React, { useEffect, useState } from "react";
import { getUserSettlementEmail, updateUserSettlementEmail } from "../../services/fetchConfig";

const SettlementInput = ({student_id}) => {
  const [isCustomEmail, setIsCustomEmail] = useState(false);
  const [customEmail, setCustomEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [customEmailErr, setCustomEmailErr] = useState(false);
  const changeCustomEmail = (e) =>{
    const isValid = /\S+@\S+\.\S+/.test(customEmail);
    setCustomEmailErr(!isValid);
    setCustomEmail(e.target.value)
  }
  const toggleEmail = ()=>{
    setIsCustomEmail((prev) => !prev)
    setCustomEmail("")
    setCustomEmailErr(false)
  }
  useEffect(()=>{
    console.log("user id : : : : ",student_id);
    setSuccess(false)
    getUserSettlementEmail(student_id).then(res=>{
        console.log("email res : ",res);
        setUserEmail(res.user_email)
    }).catch(err=>{
        console.log(err);
    })
  },[student_id])

  const handleSubmit = (e)=>{
    if(customEmail&&!customEmailErr){
      updateUserSettlementEmail(student_id,customEmail).then(res=>{
          setSuccess(true)
          console.log("email res : ",res);
          setUserEmail(customEmail)
          setCustomEmail("")
          setCustomEmailErr(false)
          setIsCustomEmail(false)
          setTimeout(()=>setSuccess(false),5000)
      }).catch(err=>{
          console.log(err);
      })
    }
  }
  return (
    <div className="container mt-4 p-0 my-4">
      <h1 className="text-sm">
        Current Settlement Email: <span className="text-primary">{userEmail||"unknown@xyz.com"}</span>
      </h1>

      {!success&&(<div className="form-check d-flex align-items-center gap-2">
        <input
          type="checkbox"
          className="form-check-input"
          checked={isCustomEmail}
          onChange={toggleEmail}
        />
        <label className="form-check-label">change settlement email</label>
      </div>)}
      {
        success&&<div className="text-success my-4">updated settlement email successfully</div>
      }
      {isCustomEmail && (
        <div className="d-flex gap-2">
            <input
          type="email"
          className="form-control mt-2 w-70"
          placeholder="Enter custom email"
          value={customEmail}
          onChange={changeCustomEmail}
        />
        <button className="btn btn-primary w-25" onClick={handleSubmit}>Submit</button>
        </div>
      )}
      {customEmailErr && (
        <div className="text-danger">Please enter a valid email</div>
      )}
    </div>
  );
};

export default SettlementInput;
